import { render, staticRenderFns } from "./EditNetworkModal.vue?vue&type=template&id=2057cb65&"
import script from "./EditNetworkModal.vue?vue&type=script&lang=js&"
export * from "./EditNetworkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports